//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'BSA',
  data() {
    return {
      defaultJson:{
        "Dubois": "Dubois",
        "Height": "身高",
        "Mosteller": "Mosteller",
        "Weight": "体重",
        "Boyd": "Boyd",
        "Haycock": "Haycock",
        "Body Surface Area": "BSA"
      },
      form:{
        h:'',
        w:'',
        gender:null,
      },
      method:4,
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:4,name:'国内常用'},
        {value:5,name:'国内儿童常用'},
        {value:0,name:'Boyd'},
        {value:1,name:'Dubois'},
        {value:2,name:'Haycock'},
        {value:3,name:'Mosteller'},
      ],
       dataList2: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
      res:'...',
      activeIndex:0,
      
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.activeIndex = index
      // this.form.h = ''
      // this.form.w = ''
      // this.form.gender = null
      this.method = item.value;
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      console.log(self.form,'self.form');
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (self.method==0 ||self.method==5) {
        form.h='0'
        form.gender='0'
      }else if(self.method==1||self.method==2||self.method==3){
        form.gender='0'
      }
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0 
        if (self.method == 0) {
          // (4.688 * ((1000*w)^(0.8168 - (0.0154 * log(1000*w)))))/10000
          // (4.688 * (Math.pow ((1000*w),(0.8168 - (0.0154 * log(1000*w))))))/10000
          result = (4.688 * (Math.pow ((1000*form.w),(0.8168 - (0.0154 * Math.log10(1000*form.w))))))/10000
        } else if (self.method == 1){
          // 0.007184 * h^0.725 * w^0.425
          result = 0.007184 * Math.pow(form.h,0.725) * Math.pow(form.w,0.425)
        }else if (self.method == 2){
          // 0.024265 * h^0.3964 * w^0.5378
          // 0.024265 * Math.pow(h,0.3964) * Math.pow(w,0.5378)
          result = 0.024265 * Math.pow(form.h,0.3964) * Math.pow(form.w,0.5378)
        }else if (self.method == 3){
          // sqrt(w * h/3600)	
          result = Math.sqrt(form.w * form.h/3600)	
        }else if (self.method == 4){
          // sqrt(w * h/3600)	
          if (form.gender =='1') { // 男
            result = 0.0057 * form.h + 0.0121 * form.w+0.0882
          } else {
            result = 0.0073 * form.h + 0.0127 * form.w-0.2106
          }	
        }else if (self.method == 5){
          if (form.w >= 30) {
            result = form.w*0.035 +0.1   
          } else {
            result = (form.w-30)* 0.02+1.05              
          }
        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/BSA.vue